import payJimLogo from '../../assets/svg/payjim-logo.svg';

const Footer = () => (
  <footer className="flex w-full justify-center p-2">
    <div className="flex items-center justify-center gap-3">
      <span>powered by</span>
      <img src={payJimLogo} alt="PayJim Logo" />
    </div>
  </footer>
);

export default Footer;
